import { Button, mergeClasses } from '@fluentui/react-components';
import { IViaeroButtonProps } from './ViaeroButton.types';
import useViaeroButtonStyles from './ViaeroButton.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ViaeroButton = (props: IViaeroButtonProps) => {
    const { text, className, customStyle, testId, click, disabled, startIcon, endIcon } = props;

    const styles = useViaeroButtonStyles();

    return (
        <Button
            appearance={'primary'}
            onClick={click}
            data-testid={testId}
            className={
                className ? mergeClasses(styles.viaeroButton, className) : styles.viaeroButton
            }
            disabled={disabled}
            style={customStyle}
        >
            {startIcon && <FontAwesomeIcon icon={startIcon} className={styles.startIcon} />}
            {text}
            {endIcon && <FontAwesomeIcon icon={endIcon} className={styles.endIcon} />}
        </Button>
    );
};

export default ViaeroButton;
